module.exports = __webpack_public_path__ + "static/testing-8bf5d25493f495ce311586a234fbbcba.png";